(function() {
  var Action,
      RouteSnapshot,
      ActionChain,
      ActionsManager;
  
  // undo/executable action
  Action = function(executeFn, undoFn) {
    this.name = "Default";
    this.undo = undoFn;
    this.execute = executeFn;
    this.next = this.prev = null;
  };

  // record history point with ability to fully restore route
  RouteSnapshot = function(map, serialized) {
    this.name = "RouteSnapshot";
    this.map = map;
    this.serialized = serialized;
  };
  RouteSnapshot.prototype.restore = function() {
    this.map.clearMap();
    this.map.routes = [];
    if(this.serialized.routes) {
      var map = this.map;
      _.each(this.serialized.routes, function(routeSerialized) {
        var route = new rwgps.Route(routeSerialized, this.map, {planning: true});
        route.routeData = routeSerialized.routeData;
        route.tripData = routeSerialized.tripData;
        if(routeSerialized.active)
          map.addRoute(route, true);
        else
          map.addRoute(route);
      }, this);
    } else {
      // support old serialization that supported only one route
      // once we deploy the multi-route support, we don't want the route planner
      // to bust for users that have a saved route from prior to release
      this.map.loadRouteForEdit(this.serialized, true);
    }
    this.map.saveSnapshotLocally(this);
  };
  RouteSnapshot.prototype.execute = RouteSnapshot.prototype.restore;
  

  // arguments are a list of actions to compose linearly, and will
  // undo/execute as a group
  ActionChain = function() {
    this.actions = _.toArray(arguments);
    this.next = this.prev = null;
  };
  _.extend(ActionChain.prototype, {
    undo: function() {
      for(var i=this.actions.length-1; i >= 0; --i) {
        this.actions[i].undo();
      }
    },
    execute: function() {
      for(var i=0; i < this.actions.length; ++i) {
        this.actions[i].execute();
      }
    }
  });

  // implement undo manager as doubly linked list
  ActionsManager = function() {
    this.curr = null;
  };
  _.extend(ActionsManager.prototype, {
    printDebug: function() {
      var curr = this.curr, lastAction;
      if(!curr) {
        console.log("EMPTY ACTIONS"); // eslint-disable-line no-console
        return;
      }
      // find head
      while(curr.prev) { curr = curr.prev; }
      // print in order
      do {
        lastAction = this.curr === curr;
        console.log("NAME " + curr.name, "UNDO " + !!curr.undo, "REDO " + !!curr.execute, "NEXT " + !!curr.next, "PREV " + !!curr.prev, "ISLAST? " + lastAction); // eslint-disable-line no-console
      } while(curr = curr.next); // eslint-disable-line no-cond-assign
    },
    execute: function(action) {
      action.execute();
      this.add(action);
    },
    clear: function() {
      this.curr = null;
    },
    chain: function(action) {
      if(!this.curr) {
        this.add(action);
      } else if(this.curr.restore && action.restore) {
        // update the snapshot
        this.curr.serialized = action.serialized;
      } else {
        console.warn("Need to implement use of ActionChain for non-snapshot chaining"); // eslint-disable-line no-console
      }
    },
    add: function(action) {
      if(action.undo || (this.curr && this.curr.restore)) {
        action.prev = this.curr;
        if(this.curr)
          this.curr.next = action;
      }
      this.curr = action;
    },
    manualUndoTo: function(action) {
      // assumes we're working with snapshots.
      // undo functionality was overridden, so inject this snapshot in
      // and move curr back as if undo took place properly
      if(this.curr) {
        if(this.curr.prev) {
          this.curr.prev.next = action;
          action.prev = this.curr.prev;
        }
        this.curr.prev = action;
        action.next = this.curr;
      }
      this.curr = action;
    },
    noopAction: function(nextAction) {
      var noopAction = new Action(function(){});
      noopAction.name = "noop";
      noopAction.next = nextAction;
      return noopAction;
    },
    canUndo: function() {
      return this.curr && ((this.curr.prev && this.curr.prev.restore) || this.curr.undo);
    },
    revert: function() {
      if(this.curr && this.curr.restore) 
        this.curr.restore();
    },
    undo: function() {
      if(!this.curr) return;
      // if last state is a full restore, don't perform undo just
      // perform restore
      if(this.curr.prev && this.curr.prev.restore) {
        this.curr = this.curr.prev;
        this.curr.restore();
      } else if(this.curr.undo) {
        // undo and step back in history
        this.curr.undo();
        if(this.curr.prev) {
          this.curr = this.curr.prev;
        } else {
          // we're at the start of history, so inject a noop action
          this.curr = this.noopAction(this.curr);
        }
      }
    },
    redo: function() {
      if(!this.curr || !this.curr.next) return;
      // step forward and execute
      this.curr = this.curr.next;
      this.curr.execute();
    }
  });

  module.exports = {
    Action: Action,
    RouteSnapshot: RouteSnapshot,
    ActionChain: ActionChain,
    ActionsManager: ActionsManager
  };
})();




// WEBPACK FOOTER //
// ./public/javascripts/js_maps/actions.js